import { Fragment, useEffect } from "react";
import { IconButton, Tooltip } from "@material-ui/core";

import DeleteIcon from "@material-ui/icons/Delete";
import DetalleUsuario from "./DetalleUsuario";
import EditIcon from "@material-ui/icons/Edit";
import EliminarUsuario from "./EliminarUsuario";
import FormUsuario from "./FormUsuario";
import MeditocBody from "../../../utils/MeditocBody";
import MeditocHeader from "../../../utils/MeditocHeader";
import MeditocTable from "../../../utils/MeditocTable";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import RefreshIcon from "@material-ui/icons/Refresh";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { fnEmpty } from "../../../../settings/preventConfig";
import { getUsuarioColumns } from "../../../../models/UsuarioModel";
import { useLogin } from "../../../../context/LoginContext";
import { useUsuario } from "../../../../context/UsuarioContext";

export default function Usuario() {
    const {
        listaUsuarios,
        usuarioSeleccionado,
        handleChangeUsuarioSeleccionado,
        handleClickNuevoUsuario,
        handleClickEditarUsuario,
        handleClickDetalleUsuario,
        handleClickEliminarUsuario,
        handleClickRefrescarDatos,
    } = useUsuario();
    const { usuarioPermisos } = useLogin();
    const permisos = usuarioPermisos["1"].Submodulos["1"];

    useEffect(() => {
        handleClickRefrescarDatos();
        // eslint-disable-next-line
    }, []);

    return (
        <Fragment>
            <MeditocHeader title={permisos.Nombre}>
                {permisos.Botones["1"] !== undefined && ( //Nuevo usuario
                    <Tooltip title={permisos.Botones["1"].Nombre} arrow>
                        <IconButton onClick={handleClickNuevoUsuario}>
                            <PersonAddIcon className="color-0" />
                        </IconButton>
                    </Tooltip>
                )}
                {permisos.Botones["2"] !== undefined && ( //Detalle usuario
                    <Tooltip title={permisos.Botones["2"].Nombre} arrow>
                        <IconButton onClick={handleClickDetalleUsuario}>
                            <VisibilityIcon className="color-0" />
                        </IconButton>
                    </Tooltip>
                )}
                {permisos.Botones["3"] !== undefined && ( //Editar usuario
                    <Tooltip title={permisos.Botones["3"].Nombre} arrow>
                        <IconButton onClick={handleClickEditarUsuario}>
                            <EditIcon className="color-0" />
                        </IconButton>
                    </Tooltip>
                )}
                {permisos.Botones["4"] !== undefined && ( //Eliminar usuario
                    <Tooltip title={permisos.Botones["4"].Nombre} arrow>
                        <IconButton onClick={handleClickEliminarUsuario}>
                            <DeleteIcon className="color-0" />
                        </IconButton>
                    </Tooltip>
                )}
                {permisos.Botones["5"] !== undefined && ( //Actualizar tabla
                    <Tooltip title={permisos.Botones["5"].Nombre} arrow>
                        <IconButton onClick={handleClickRefrescarDatos}>
                            <RefreshIcon className="color-0" />
                        </IconButton>
                    </Tooltip>
                )}
            </MeditocHeader>
            <MeditocBody>
                <MeditocTable
                    id="iIdUsuario"
                    data={listaUsuarios}
                    row={usuarioSeleccionado}
                    columns={getUsuarioColumns()}
                    setRow={handleChangeUsuarioSeleccionado}
                    fnDoubleClick={permisos.Botones["2"] !== undefined ? handleClickDetalleUsuario : fnEmpty}
                />
            </MeditocBody>
            <FormUsuario />
            <DetalleUsuario />
            <EliminarUsuario />
        </Fragment>
    );
}
